/**
 * GLY-363: client for GET /api/rower/guardianship-status.
 * Tells a signed-in rower whether they currently need parental consent
 * to use Glyyd fully with coaches (minor age band with no active guardian link).
 */

export type RowerGuardianshipStatusReason = 'parent_withdrew';

export interface PendingReconsentSummary {
  id: string;
  parentEmail: string;
  expiresAt: string;
  status: string;
}

export interface RowerGuardianshipStatus {
  needsParentalConsent: boolean;
  reason?: RowerGuardianshipStatusReason;
  /** Present when the rower has an open re-consent request awaiting parent approval. */
  pendingReconsent?: PendingReconsentSummary | null;
}

function apiBase(): string {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  return isLocalhost ? 'http://localhost:3001' : '';
}

export async function fetchRowerGuardianshipStatus(
  accessToken: string
): Promise<RowerGuardianshipStatus> {
  const response = await fetch(`${apiBase()}/api/rower/guardianship-status`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error || 'Failed to load guardianship status');
  }

  return (await response.json()) as RowerGuardianshipStatus;
}
